import { BASE_URL, GET, SERVICES_LIST, DOWNLOAD_SERVICES_LIST, PAGE_SIZE } from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";

export const fetchServicesList = async (filter, searchKey,next,/*status=""*/customer="",serviceType="",orderBy="",pageSize=PAGE_SIZE) => {
    const token = await getAccessToken();
    let url = `${BASE_URL}${SERVICES_LIST}`;
    if(filter){    
      filter = filter.replace ("filter=&", "");
  }
  let array = [
    {
      key:"filter",
      value:filter
    },
    {
      key:"requestId",
      value:encodeURIComponent(searchKey)
    },
    // {
    //   key:"status",
    //   value:encodeURIComponent(status)
    // },
    {
      key:"customer",
      value:encodeURIComponent(customer)
    },
    {
      key:"services",
      value:encodeURIComponent(serviceType)
    },
    {
      key:"orderBy",
      value:encodeURIComponent(orderBy)
    },
    {
      key:"next",
      value:next
    },
    {
      key:"pageSize",
      value:pageSize
    }
     // download true
  ]  

  let queryString=``;
  array.forEach((item)=>{
    if(item.value){
      if(queryString){
        queryString=queryString+`&${item.key}=${item.value}`
      }else{
        queryString=`${item.key}=${item.value}`
      }
    }
  })
 
  if(queryString){
    url=`${url}?${queryString}`;
    url = url.replace ("filter=&", "");
}
    
    const response =  fetch(url, {
        method: GET,
        headers: {
          "Content-Type": "application/json",
          "userAuth" : `bearer ${token}`
        },
      })
      .then(statusParsing)
      .then(jsonParsing);
      
      return response;

};

export const downloadServiceList = async (searchKey,customer,serviceType,orderBy,isDownalod) => {
  const token = await getAccessToken();
  let url = `${BASE_URL}${SERVICES_LIST}`;
  // if (filter) {
  //   filter = filter.replace("filter=&", "");
  // }
  let array = [
    {
      key:"requestId",
      value:encodeURIComponent(searchKey)
    },
    {
      key:"customer",
      value:encodeURIComponent(customer)
    },
    {
      key:"services",
      value:encodeURIComponent(serviceType)
    },
    {
      key:"orderBy",
      value:encodeURIComponent(orderBy)
    },
    {
      key:"isDownalod",
      value:isDownalod
    },
  ]

  let queryString = ``;
  array.forEach((item) => {
    if (item.value) {
      if (queryString) {
        queryString = queryString + `&${item.key}=${item.value}`
      } else {
        queryString = `${item.key}=${item.value}`
      }
    }
  })

  if (queryString) {
    url = `${url}?${queryString}`;
    url = url.replace("filter=&", "");
  }

  const response = fetch(url, {
    method: GET,
    headers: {
      "Content-Type": "application/json",
      "userAuth": `bearer ${token}`
    },
  })
    .then(statusParsing)
    .then(jsonParsing);

  return response;

};